import {
    getOrders,
    getOrdersForExport,
    getStatus,
    getAppConfig,
    sendContact,
    sendRegistration,
    downloadOrder,
    getFileNameFromContentDisposition,
    getShopInfo,
    getCountries,
    getCountrySubdivisions,
    getTaxingCategoryList,
    getShopTypeList,
    getCuitInformation,
    downloadAllOrder,
    validateNewShopName,
    getRecoveryLabel,
    getRecoveryBarCode,
    getDeliveryReceiptLabel,
    getGroupReadyForCollect
} from '../helpers/restHelpers'
import routes from '../components/router/routes'
import { statusTypes } from '../server/shared'
import { sendBlobAsLink, printBlob } from '../utils/fileUtils'
import { appEnabled } from '../server/common'

export const processGetStatusResponse = (response, history) =>
    new Promise((resolve, reject) => {

        if (!response.hasEulaAgreed && appEnabled(response.status)) {
            if (
                !!history &&
                !!history.location &&
                !!history.location.pathname &&
                history.location.pathname.includes(routes.eula.path)
            ) {
                resolve(response.status)
            } else {
                history.push(routes.eula.path)
                resolve()
            }
            return
        }


        if (response.hasCriticalNews && appEnabled(response.status)) {
            if (
                !!history &&
                !!history.location &&
                !!history.location.pathname &&
                history.location.pathname.includes(routes.criticalNews.path)
            ) {
                resolve(response.status)
            } else {
                history.push(routes.criticalNews.path)
                resolve()
            }
            return
        }

        if (history.location.pathname.includes(routes.restrictiveNew.path)) {
            history.push(routes.restrictiveNew.path)
            resolve()
            return
        }

        switch (response.status) {
            case statusTypes.Redirected:
                window.location.href = response.additionalData
                resolve(response.status)
                break
            case statusTypes.Activated:
            case statusTypes.Registered:
            case statusTypes.PendingValidation:
            case statusTypes.CustomerDisabled:
                history.push(routes.orders.path)
                resolve(response.status)
                break
            case statusTypes.Error:
                reject(response)
                break
            default:
                resolve()
        }
    })

export const getStatusAction = (history) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch({ type: 'STATUS_GET' })
        getStatus()
            .then((response) => {
                dispatch({ type: 'STATUS_GET_SUCCESS', payload: response.data })
                if (history) {
                    processGetStatusResponse(response.data, history)
                        .then(() => resolve(response.data))
                        .catch((error) => reject(error))
                } else {
                    resolve(response.data)
                }
            })
            .catch((error) => {
                dispatch({ type: 'STATUS_GET_FAILURE', payload: error })
                reject(error)
            })
    })

export const getAppConfigAction = () => (dispatch) =>
    new Promise((resolve, reject) => {
        getAppConfig()
            .then((response) => resolve(response.data))
            .catch((error) => reject(error))
    })

export const getOrdersAction = (data) => (dispatch, getState) =>
    new Promise((resolve, reject) => {
        dispatch({ type: 'ORDERS_GET' })
        getOrders(data)
            .then((response) => {
                dispatch({ type: 'ORDERS_GET_SUCCESS', payload: response })
                resolve(response)
            })
            .catch((error) => {
                dispatch({ type: 'ORDERS_GET_FAILURE', payload: error })
                reject(error)
            })
    })

export const getGroupReadyForCollectAction = () => (dispatch, getState) =>
    new Promise((resolve, reject) => {
        getGroupReadyForCollect()
            .then((response) => resolve(response.data))
            .catch((error) => reject(error))
    })

export const getOrdersForExportAction = (data) => (dispatch, getState) =>
    new Promise((resolve, reject) => {
        dispatch({ type: 'EXPORT_ORDERS_GET' })
        getOrdersForExport(data)
            .then((response) => {
                dispatch({ type: 'EXPORT_ORDERS_GET_SUCCESS', payload: response })
                resolve(response)
            })
            .catch((error) => {
                dispatch({ type: 'EXPORT_ORDERS_GET_FAILURE', payload: error })
                reject(error)
            })
    })

export const cleanStatusAction = () => (dispatch) =>
    new Promise(() => {
        dispatch({ type: 'CLEAN_STATUS' })
    })

export const downloadOrderAction = (orderId, print) => (dispatch, store) =>
    new Promise((resolve, reject) => {
        dispatch({ type: 'DOWNLOAD_ORDER' })
        downloadOrder(orderId)
            .then((response) => {
                if (print) return printBlob(response.data)
                else {
                    var fileName = getFileNameFromContentDisposition(
                        response.headers,
                        'file.pdf'
                    )
                    return sendBlobAsLink(fileName, response.data)
                }
            })
            .then((fileName) => {
                dispatch({
                    type: 'DOWNLOAD_ORDER_FULFILLED',
                    payload: fileName,
                })
                resolve(fileName)
            })
            .catch((error) => {
                dispatch({ type: 'DOWNLOAD_ORDER_REJECTED', error: error })
                reject(error)
            })
    })

export const downloadAllOrdersAction =
    (orderIds, print, perPage) => (dispatch, store) =>
        new Promise((resolve, reject) => {
            dispatch({ type: 'DOWNLOAD_ORDER' })
            downloadAllOrder(orderIds, perPage)
                .then((response) => {
                    if (print) return printBlob(response.data)
                    else {
                        let fileName = getFileNameFromContentDisposition(
                            response.headers,
                            'file.pdf'
                        )
                        return sendBlobAsLink(fileName, response.data)
                    }
                })
                .then((fileName) => {
                    dispatch({
                        type: 'DOWNLOAD_ORDER_FULFILLED',
                        payload: fileName,
                    })
                    resolve(fileName)
                })
                .catch((error) => {
                    dispatch({ type: 'DOWNLOAD_ORDER_REJECTED', error: error })
                    reject(error)
                })
        })

export const sendContactAction = (data) => (dispatch, getState) =>
    new Promise((resolve, reject) => {
        dispatch({ type: 'CONTACT_SEND' })
        sendContact(data)
            .then((response) => {
                dispatch({ type: 'ORDERS_GET_SUCCESS' })
                resolve(response)
            })
            .catch((error) => {
                dispatch({ type: 'ORDERS_GET_FAILURE', payload: error })
                reject(error)
            })
    })

export const sendRegistrationAction = (data) => (dispatch, getState) =>
    new Promise((resolve, reject) => {
        sendRegistration(data)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })

export const getShopInfoAction = (token) => (dispatch, getState) =>
    new Promise((resolve, reject) => {
        getShopInfo(token)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })

export const getCountriesAction = () =>
    new Promise((resolve, reject) => {
        getCountries()
            .then((response) => resolve(response))
            .catch((error) => reject(error))
    })

export const getCountrySubdivisionsAction = (countryName) =>
    new Promise((resolve, reject) => {
        getCountrySubdivisions(countryName)
            .then((response) => resolve(response))
            .catch((error) => reject(error))
    })

export const getTaxingCategoryListAction = () =>
    new Promise((resolve, reject) => {
        getTaxingCategoryList()
            .then((response) => resolve(response))
            .catch((error) => reject(error))
    })

export const getShopTypeListAction = () =>
    new Promise((resolve, reject) => {
        getShopTypeList()
            .then((response) => resolve(response))
            .catch((error) => reject(error))
    })

export const getCuitInformationAction = (cuit) =>
    new Promise((resolve, reject) => {
        getCuitInformation(cuit)
            .then((response) => resolve(response))
            .catch((error) => reject(error))
    })

export const validateNewShopNameAction = (shopName) =>
    new Promise((resolve, reject) => {
        validateNewShopName(shopName)
            .then((response) => resolve(response))
            .catch((error) => reject(error))
    })

export const getRecoveryLabelAction =
    (orderId, print) => (dispatch, reject) =>
        new Promise((resolve, reject) => {
            getRecoveryLabel(orderId)
                .then((response) => {
                    if (print) {
                        return printBlob(response)
                    }
                    else {
                        var fileName = getFileNameFromContentDisposition(
                            response.headers,
                            'Recuperar_paquete.pdf'
                        )
                        return sendBlobAsLink(fileName, response)
                    }
                })
                .catch((error) => {
                    reject(error)
                })
        })

export const getRecoveryBarCodeAction =
    (orderId) => (dispatch, reject) =>
        new Promise((resolve, reject) => {
            getRecoveryBarCode(orderId)
                .then((response) => resolve(response))
                .catch((error) => reject(error))
        })

export const getDeliveryReceiptLabelAction =
    (orderId, print) => (dispatch, reject) =>
        new Promise((resolve, reject) => {
            getDeliveryReceiptLabel(orderId)
                .then((response) => {
                    if (print) {
                        return resolve(printBlob(response))
                    }
                    else {
                        var fileName = getFileNameFromContentDisposition(
                            response.headers,
                            'Comprobante_entrega.pdf'
                        )
                        return resolve(sendBlobAsLink(fileName, response))
                    }
                })
                .catch((error) => {
                    reject(error)
                })
        })